import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";

import { useState } from "react";
import { handleApiError } from "@/utils/errors";
import { catchError } from "@/lib/errors";
import { toast } from "sonner";
import DotPattern from "@/components/dot-pattern";
import AboutForm from "@/features/about/components/form/about-form";
import { aboutFormSchema } from "@/features/about/components/form/schemas";
import { aboutRepo } from "@/lib/repositories";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";
import { queryClient } from "@/lib/query-client";

const AboutCreatePage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof aboutFormSchema>>({
    resolver: zodResolver(aboutFormSchema),
    defaultValues: {
      title: "",
      description: "",
      body_simple: "",
      body_wysiwyg: "",
      icon_name: "",
      order: 0,
      is_active: true,
    },
  });

  async function onSubmit(data: z.infer<typeof aboutFormSchema>) {
    setIsLoading(true);
    const [error, aboutData] = await catchError(aboutRepo.create(data));
    if (error) toast.error(handleApiError(error).message);
    if (aboutData) {
      await queryClient.invalidateQueries({ queryKey: ["abouts"] });
      toast.success(t("messages.about_create_success"));
      form.reset();
      navigate(ROUTES.ABOUT);
    }
    setIsLoading(false);
  }

  return (
    <div className="relative h-full flex flex-col items-center gap-y-3 p-3 py-4 sm:py-10 sm:p-6">
      <DotPattern />
      <AboutForm form={form} onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  );
};

export default AboutCreatePage;
